import { useContext } from 'react';
import {
  SearchVideoReference,
  SearchImageReference,
  ModalGalleryType,
} from 'src/types';
import { ResearchMediaCarousel } from '../ResearchMediaCarousel';
import SessionContext from 'src/contexts/SessionContext';

interface ResearchMediaProps {
  videos: SearchVideoReference[];
  images: SearchImageReference[];
}

export const ResearchMedia = ({ videos, images }: ResearchMediaProps) => {
  const { onChangeModalGalleryData } = useContext(SessionContext);

  const handleSetCurrentMedia = (index: number) => {
    onChangeModalGalleryData(
      true,
      ModalGalleryType.IMAGES_VIDEOS,
      [...videos, ...images],
      index
    );
  };

  if (images.length === 0 && videos.length === 0) {
    return null;
  }

  return (
    <>
      <div className="nj-thread-research-media">
        <h6 className="nj-thread-research-card--summary-title">
          Videos & Images
        </h6>

        <ResearchMediaCarousel
          videos={videos}
          images={images}
          setCurrentMedia={handleSetCurrentMedia}
        />
      </div>
    </>
  );
};
